module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product-card', {
    attrs: {
      "product": _vm.product,
      "image": _vm.image,
      "module": _vm.module
    }
  }, _vm._l((_vm.product.attributes), function(attribute) {
    return _c('div', {
      staticClass: "l-col-6@md",
      attrs: {
        "slot": "attributes"
      },
      slot: "attributes"
    }, [_c('div', {
      staticClass: "margin"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t(("" + (attribute.label)))))]), _vm._v("\n      " + _vm._s(_vm._f("attribute")(attribute.valueLabel)) + "\n    ")])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9010bec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/skyhub/ProductCard.vue
// module id = 3431
// module chunks = 0